import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../shared/header/header.component';
import { jwtDecode } from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, CommonModule, HeaderComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  constructor(private cookieService: CookieService) { }

  funcaoUser = '';
  mostrarCard = false;

  ngOnInit(): void {
    const token = this.cookieService.get('token');
    if (!token) return;

    try {
      const decoded: any = jwtDecode(token);

      const roleClaim = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
      const role = decoded?.[roleClaim] ?? decoded?.role ?? decoded?.roles;

      this.funcaoUser = Array.isArray(role) ? role[0] : (role ?? '');

      this.verificarFuncaoUser();
    } catch (error) {
      this.mostrarCard = false;
    }
  }

  verificarFuncaoUser(): void {
    this.mostrarCard =
      this.funcaoUser === 'Administrador do Sistema' ||
      this.funcaoUser === 'CEO';
  }
}